import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/auth/login`, {
        username,
        password
      });

      // Store token
      localStorage.setItem('admin_token', response.data.access_token);
      
      // Redirect to dashboard
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--color-ocean-deep) 0%, var(--color-ocean-blue) 100%)',
      padding: 'var(--spacing-lg)'
    }}>
      <div style={{
        background: 'white',
        borderRadius: 'var(--border-radius-lg)',
        padding: 'var(--spacing-2xl)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        maxWidth: '450px',
        width: '100%'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'var(--color-ocean-deep)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto var(--spacing-md) auto'
          }}>
            <LogIn size={40} color="white" />
          </div>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2rem',
            color: 'var(--color-dark-slate)',
            marginBottom: '0.5rem'
          }}>
            Admin Login
          </h1>
          <p style={{ color: 'var(--color-granite-gray)' }}>
            Manage your property photos
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 'var(--spacing-md)' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '600',
              color: 'var(--color-dark-slate)'
            }}>
              Username
            </label>
            <input
              type="text"
              data-testid="username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.875rem',
                border: '2px solid var(--color-coastal-fog)',
                borderRadius: 'var(--border-radius)',
                fontSize: '1rem',
                fontFamily: 'var(--font-body)',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = 'var(--color-ocean-deep)'}
              onBlur={(e) => e.target.style.borderColor = 'var(--color-coastal-fog)'}
            />
          </div>

          <div style={{ marginBottom: 'var(--spacing-lg)' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '600',
              color: 'var(--color-dark-slate)'
            }}>
              Password
            </label>
            <input
              type="password"
              data-testid="password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.875rem',
                border: '2px solid var(--color-coastal-fog)',
                borderRadius: 'var(--border-radius)',
                fontSize: '1rem',
                fontFamily: 'var(--font-body)',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = 'var(--color-ocean-deep)'}
              onBlur={(e) => e.target.style.borderColor = 'var(--color-coastal-fog)'}
            />
          </div>

          {error && (
            <div style={{
              padding: 'var(--spacing-md)',
              background: '#fee',
              border: '1px solid #fcc',
              borderRadius: 'var(--border-radius)',
              color: '#c33',
              marginBottom: 'var(--spacing-md)',
              fontSize: '0.9375rem'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="login-btn"
            disabled={loading}
            style={{
              width: '100%',
              padding: '1rem',
              background: loading ? 'var(--color-harbor-mist)' : 'var(--color-ocean-deep)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--border-radius)',
              fontSize: '1.125rem',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.3s ease',
              fontFamily: 'var(--font-body)'
            }}
            onMouseEnter={(e) => {
              if (!loading) e.target.style.background = 'var(--color-ocean-blue)';
            }}
            onMouseLeave={(e) => {
              if (!loading) e.target.style.background = 'var(--color-ocean-deep)';
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={{
          marginTop: 'var(--spacing-lg)',
          padding: 'var(--spacing-md)',
          background: 'var(--color-coastal-fog)',
          borderRadius: 'var(--border-radius)',
          fontSize: '0.875rem',
          color: 'var(--color-granite-gray)',
          textAlign: 'center'
        }}>
          Default credentials: admin / admin123<br />
          Please change after first login
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
